<style src='style.scss'>

</style>

<article class="mbsc-col-12 banner">
  <div class="mbsc-row">
    <div class="left-panel mbsc-col-12 mbsc-col-md-5">
      <header>
        <h1>{title}</h1>
      </header>
      <p>{@html description}</p>
    </div>
    <div class="right-panel mbsc-col-12 mbsc-col-md-7">
      <img class="mbsc-media-fluid" src="{image}" alt="d-ns home">
    </div>
  </div>
</article>

<script>
  import { onMount, afterUpdate, createEventDispatcher } from 'svelte';

  const DEBUG = document.location.protocol === 'http:' ? true : false;

  const dispatch = createEventDispatcher();

  export let title = 'Únete a nuestra comunidad';
  export let description = 'Únete al único Studio que se mueve contigo, desde tu PC o teléfono celular, todas nuestras sesiones siempre disponibles. <br>Todas tus clases sin salir de casa. <a target="_blank" href="https://twitter.com/search?q=%23QuedateEnCasa&src=typeahead_click">#quedateencasa</a>';
  export let image = '/images/d-ns-learn.jpg';

  onMount(async () =>{});
</script>
